import { useEffect, useRef } from 'react'
import { Spacer } from '../Spacer'

export function PoliticaCookiesContent() {
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    container.innerHTML = ''

    const script = document.createElement('script')
    script.id = 'CookieDeclaration'
    script.src =
      'https://consent.cookiebot.com/22418cb6-2606-4720-8cb0-83ac5b77153f/cd.js'
    script.type = 'text/javascript'
    script.async = true
    container.appendChild(script)

    return () => {
      container.innerHTML = ''
    }
  }, [])

  return (
    <div className="flex flex-col gap-2">
      <h1 className={`w-full px-0 text-h4 text-neutral-900`}>
        POLÍTICA DE COOKIES
      </h1>
      <Spacer size="32px" />
      <div
        ref={containerRef}
        className={`
          flex w-full max-w-full flex-col gap-2 overflow-hidden

          [&_*]:!max-w-full [&_*]:break-words

          [&_div[style*='font-size:200px']]:!hidden
          [&_div[style*='font-size:_200px']]:!hidden
        `}
      />
    </div>
  )
}
